import React from 'react'
import { connectSortBy } from 'react-instantsearch-dom'
import CustomSelect from '../customSelect'

const SortBy = ({items, refine, createURL}) => {
  let options = []
  
  items.forEach(item => {
    options.push({ 'value': item.value, 'label': item.label })
  })

  const onChangeFunc = (optionSelected) => {
    refine(optionSelected.value)
  }

  const onChangeMobile = (e) => {
    refine(e.target.value)
  }

  return (
    <CustomSelect
      options={options}
      onChange={onChangeFunc}
      dynamicValue={items.find(item => item.isRefined)}
      onChangeMobile={onChangeMobile}
      classes="react-select-container--sorting"
    />
  )
}

const CustomSort = connectSortBy(SortBy)

export default CustomSort